import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los empresas
export const getEmpresas = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/empresas`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener empresas",
    };
  }
};

// ✅ GET: Traer una empresa por ID
export const getEmpresaById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/empresas/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener empresa",
    };
  }
};

// ✅ POST: Crear nuevo empresa
export const postEmpresa = async (empresaData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/empresas`;

  try {
    const resp = await axios.post(url, empresaData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear empresa",
    };
  }
};

// ✅ PUT: Actualizar empresa
export const putEmpresa = async (id, empresaData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/empresas/${id}`;

  try {
    const resp = await axios.put(url, empresaData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar empresa",
    };
  }
};

// ✅ DELETE: Desactivar empresa
export const deleteEmpresa = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/empresas/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar empresa",
    };
  }
};
